module.exports = __webpack_public_path__ + "img/icon-star.a152499d.svg";